import { STORAGE_KEYS } from '../shared/constants';

var _memberData = {};

/**
 * @description : Returns true if the user is authenticated else returns false
 * @returns {Boolean} true when user is authenticated
 */
const _isAuthenticated = () => {
  const sessionId = _getItem(STORAGE_KEYS.AUTH_TOKEN);
  return sessionId ? true : false;
};

/**
 * @description : Retrieve a key from the browser storage. Function will first look in
 * Local Storage; if it is not found there it will look in Session Storage
 * @param {String} key : Name of key to get from storage
 * @returns {Boolean}
 */
const _getItem = key => {
  if (!_memberData[key]) {
    _memberData[key] = window.sessionStorage.getItem(key);
  }

  return _memberData[key];
};

/**
 * @description : Set or replace a key in browser storage. Default storage area will
 * be Local Storage, unless storage location of 'session' is specified
 * then it will be Session Storage.
 * @param {String} key : Name of value being placed in storage
 * @param {Mixed} val : Value to place in storage
 * @param {String} storage : Which storage area to use (session/local; Default:local)
 * @returns {Mixed} Value placed in storage
 */
const _setItem = (key, val, storage) => {
  _memberData[key] = val;

  if (storage === 'session') {
    window.sessionStorage.setItem(key, val);
  } else {
    window.localStorage.setItem(key, val);
  }

  return _memberData[key];
};

/**
 * @description : Delete a key from Session or Local Storage
 * @param {String} key Name of key to remove from storage
 * @param {String=} storage Name of storage area (session/local; Default: local)
 */
const _removeItem = (key, storage) => {
  delete _memberData[key];

  if (storage === 'session') {
    window.sessionStorage.removeItem(key);
  } else {
    window.localStorage.removeItem(key);
  }
};

/**
 * @description : Completely erase all values from local storage that are not prefixed with '__'
 */
const _clear = () => {
  var i;
  _memberData = {};
  for (i in window.localStorage) {
    if (i.indexOf('__') !== 0) {
      _removeItem(i);
    }
  }

  window.sessionStorage.clear();
};

/**
 * @description : Completely erase ALL values from local storage, EVEN those that are prefixed with '__'
 */
const _clearAll = () => {
  _memberData = {};
  window.sessionStorage.clear();
};

const SessionService = {
  isAuthenticated: _isAuthenticated,
  clear: _clear,
  clearAll: _clearAll,
  getItem: _getItem,
  setItem: _setItem,
  removeItem: _removeItem,
};

export default SessionService;
